@if (corporateTaxEntity$ | async) {
  <form [formGroup]="balansEnResultatenRekeningFg">

    <div class="d-flex mb-2" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px;"></div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="col-2">
            <p
              style="width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin: 0;">{{ item.value.naamVennootschap }}</p>
          </div>
        </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px"><p>Netto omzet</p></div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="col-2" formGroupName="nettoOmzet">
            @for (_ of item.get('nettoOmzet')?.value; track $index; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                  [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="nettoOmzet"></snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px"><p>Mutatie onderhanden werk</p></div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="col-2" formGroupName="wijzigingOnderhandenWerk">
            @for (_ of item.get('wijzigingOnderhandenWerk')?.value; track $index; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                  [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="wijzigingOnderhandenWerk"></snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px"><p>Overige opbrengsten</p></div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="col-2" formGroupName="overigeOpbrengsten">
            @for (_ of item.get('overigeOpbrengsten')?.value; track $index; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                  [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="overigeOpbrengsten"></snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Inkoopkosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="inkoopwaardeVerkopen">
              @for (_ of item.get('inkoopwaardeVerkopen')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="inkoopwaardeVerkopen"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Inhuur derden</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="kostenUitbesteedWerk">
              @for (_ of item.get('kostenUitbesteedWerk')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="kostenUitbesteedWerk"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Lonen en salarissen</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="lonenEnSalarissen">
              @for (_ of item.get('lonenEnSalarissen')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="lonenEnSalarissen"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Sociale lasten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="socialeLasten">
              @for (_ of item.get('socialeLasten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="socialeLasten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Pensioenlasten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="pensioenLasten">
              @for (_ of item.get('pensioenLasten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="pensioenLasten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Overige personeelskosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="overigePersoneelskosten">
              @for (_ of item.get('overigePersoneelskosten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="overigePersoneelskosten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Ontvangen vergoedingen</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="ontvangenVergoedingenEnSubsidies">
              @for (_ of item.get('ontvangenVergoedingenEnSubsidies')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="ontvangenVergoedingenEnSubsidies"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Afschrijving goodwill</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="afschrijvingenGoodwill">
              @for (_ of item.get('afschrijvingenGoodwill')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="afschrijvingenGoodwill"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Afschrijving immateriele activa</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="afschrijvingOverigeImmaterieleActiva">
              @for (_ of item.get('afschrijvingOverigeImmaterieleActiva')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="afschrijvingOverigeImmaterieleActiva"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Afschrijving gebouwen</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="afschrijvingenGebouwen">
              @for (_ of item.get('afschrijvingenGebouwen')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="afschrijvingenGebouwen"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Afschrijving machines</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="afschrijvingenMachines">
              @for (_ of item.get('afschrijvingenMachines')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="afschrijvingenMachines"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Afschrijving overig</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="afschrijvingenOverig">
              @for (_ of item.get('afschrijvingenOverig')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="afschrijvingenOverig"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Auto- en transportkosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="autoEnTransportKosten">
              @for (_ of item.get('autoEnTransportKosten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="autoEnTransportKosten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Huisvestingskosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="huisvestingsKosten">
              @for (_ of item.get('huisvestingsKosten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="huisvestingsKosten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Onderhoudskosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="onderhoudsKosten">
              @for (_ of item.get('onderhoudsKosten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="onderhoudsKosten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Verkoopkosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="verkoopKosten">
              @for (_ of item.get('verkoopKosten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="verkoopKosten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Overige kosten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="overigeKosten">
              @for (_ of item.get('overigeKosten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="overigeKosten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Financiële baten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="financieleBaten">
              @for (_ of item.get('financieleBaten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="financieleBaten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Financiële lasten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="financieleLasten">
              @for (_ of item.get('financieleLasten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="financieleLasten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Resultaat deelnemingen</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="resultaatDeelnemingen">
              @for (_ of item.get('resultaatDeelnemingen')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="resultaatDeelnemingen"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Buitengewone baten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="buitengewoneBaten">
              @for (_ of item.get('buitengewoneBaten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="buitengewoneBaten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p>Buitengewone lasten</p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="col-2" formGroupName="buitengewoneLasten">
              @for (_ of item.get('buitengewoneLasten')?.value; track $index; let j = $index) {
                <div [formGroupName]="j">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'"
                                                    [prefix]="i === index - 2 ? '€  -' : '€'" [showAllDecimals]="false"
                                                    align="right"
                                                    class="custom-input-150"
                                                    formControlName="bedrag"
                                                    id="buitengewoneLasten"></snelstart-ui-number-form-control>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="pt-3">
      <div class="d-flex" formArrayName="balansEnResultatenrekening">
        <div class="col col-1" style="min-width: 308px"><p><b>Resultaat</b></p></div>
        @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
          <div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [formControl]="resultaatControls[i]"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150 custom-readonly"
                prefix="€">
              </snelstart-ui-number-form-control>
            </div>
          </div>
        }
      </div>
    </div>

  </form>
}
